import currencyCodes from "currency-codes";

// Full ISO 4217 currency list for the admin's "Add a Currency" picker —
// currency-codes is a tiny, dependency-free data package (just the
// standard's code/name/country list, no conversion/money logic), so this
// replaces free-typing a 3-letter code with picking the real currency by
// name/code, with no meaningful bundle-size cost.
const ALL_CURRENCIES = currencyCodes.data
  .filter((c) => c.code && c.currency)
  .map((c) => ({ code: c.code, name: c.currency }))
  .sort((a, b) => a.code.localeCompare(b.code));

export default ALL_CURRENCIES;
